import { SurveyQuestion } from './survey-question.model';

/**
 * Model for Survey Template.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class SurveyTemplate {
    id = -1;
    title: string;
    description: string;
    questions: SurveyQuestion[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/survey/survey-template.model.ts